'use strict';

const {
	withoutHiddenFacebookAddressDiffs
} = require('../../../../../shared/services/hiddenFacebookAddressConflicts.js');

// if address is not verified we don't show conflicts at all, if service area is not verified, we don't show conflicts for google and bing
function serviceAreaVerified(place) {
	return place.verification?.serviceAreas?.status ? true : false;
}

function addressVerified(place) {
	return place.verification?.addressAndCoordinates?.status ? true : false;
}

function countLocationConflicts(siteName, place, enabled) {
	if (!addressVerified(place)) {
		return 0;
	}

	const networkDataDiffs = [
		enabled.google && serviceAreaVerified(place) ? place.google?.validation?.dataDiff : null,
		enabled.facebook
			? withoutHiddenFacebookAddressDiffs(siteName, place.fb?.validation?.dataDiff)
			: null,
		enabled.bing && serviceAreaVerified(place) ? place.bing?.validation?.dataDiff : null,
		enabled.ptv ? place.ptv?.validation?.dataDiff : null,
		enabled.apple ? place.apple?.validation?.dataDiff : null
	].filter(Boolean);

	// Merge all dataDiffs into unique fields (same field in multiple networks = 1 conflict)
	const uniqueConflicts = networkDataDiffs.reduce((acc, dataDiff) => {
		Object.entries(dataDiff).forEach(([key, value]) => {
			if (key !== 'chain' && value?.hasDiff) {
				acc[key] = true;
			}
		});
		return acc;
	}, {});

	return Object.keys(uniqueConflicts).length;
}

module.exports = { countLocationConflicts };
